import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainSliceDTO } from './types'

export const DOMAIN_FOR_SELECT_AB_TEST_FRAGMENT: TypedDocumentNode<DomainSliceDTO> = gql`
  fragment DomainForSelectABTestFragment on Domain {
    id
    name
    activeAbTest {
      id
    }
  }
`
